import type { FunctionComponent } from 'react';
import ReactPaginate from 'react-paginate';
import * as styles from './Pagination.module.css';

const PAGE_RANGE_DISPLAYED = 3;
const MARGIN_PAGES_DISPLAYED = 1;

type PaginationProps = {
  pageCount: number;
  currentPage: number;
  containerClassName?: string;
  onPageChange: (selectedItem: { selected: number }) => void;
};

// pageCount: the total number of pages
// currentPage: the selected page number
// onPageChange: the method to call when a page is clicked
const Pagination: FunctionComponent<PaginationProps> = ({
  pageCount,
  currentPage,
  containerClassName = '',
  onPageChange,
}) => (
  <div className={containerClassName}>
    <ReactPaginate
      pageCount={pageCount}
      forcePage={currentPage}
      pageRangeDisplayed={PAGE_RANGE_DISPLAYED}
      marginPagesDisplayed={MARGIN_PAGES_DISPLAYED}
      previousLabel={<i className="fal fa-angle-left" />}
      nextLabel={<i className="fal fa-angle-right" />}
      containerClassName={styles.container}
      activeClassName={styles.active}
      pageClassName={styles.page}
      previousClassName={styles.previous}
      nextClassName={styles.next}
      disabledClassName={styles.disabled}
      breakClassName={styles.paginationBreak}
      onPageChange={onPageChange}
    />
  </div>
);

export default Pagination;
